import { stripeKeyData } from '../app';

$(document).ready(function()
{
	let stripeKeyValue = stripeKeyData();
	var stripe = Stripe(stripeKeyValue);
	var elements = stripe.elements();
	var cvv = elements.create('cardCvc',{});
	cvv.mount('#card-cvv');
	var expiry = elements.create('cardExpiry', {});
	expiry.mount('#card-expiry');
	var card = elements.create('cardNumber', 
	{
	    hidePostalCode: true,
	   
	});
	card.mount('#card-number');
	$("#card-cvv").addClass('card-cvv');
	$("#card-expiry").addClass('card-expiry');
	$("#card-number").addClass('card-number');
	card.addEventListener('change', function(event) 
	{
	    var displayError = document.getElementById('card-errors');
	    if (event.error) {
	        displayError.textContent = event.error.message;
	    } else {
	        displayError.textContent = '';
	    }
	});
	const cardHolderName = document.getElementById('card-holder-name');
	const cardButton = document.getElementById('card-button');
	const clientSecret = cardButton.dataset.secret;
	cardButton.addEventListener('click', async (e) => 
	{
	    const 
	    {
	        setupIntent,
	        error
	    } = await stripe.confirmCardSetup(
	        clientSecret, {
	            payment_method: {
	                card: card,
	                billing_details: {
	                    name: cardHolderName.value
	                }
	            }
	        }
	    );
	    if (error) {
	        console.log("error");
	        var errorElement = document.getElementById('card-errors');
	        errorElement.textContent = error.message;
	    } else {
	        console.log("payment");

	        paymentMethodHandler(setupIntent.payment_method);
	    }
	});

	function paymentMethodHandler(payment_method) 
	{
	    var form = document.getElementById('subscribe-form');
	    var hiddenInput = document.createElement('input');
	    hiddenInput.setAttribute('type', 'hidden');
	    hiddenInput.setAttribute('name', 'payment_method');
	    hiddenInput.setAttribute('value', payment_method);
	    form.appendChild(hiddenInput);
	    form.submit();
	}
});